import React, { useState, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";

const ThroughputProfileSettingsHelpModal = () => {
  const [open, setOpen] = useState(false);
  const actions = useContext(ActionsContext);
  actions.recv("open-settings-help", function () {
    setOpen(true);
  });
  const doClose = () => setOpen(false);
  if (open !== true) {
    return null;
  }

  return (
    <Modal
      title="Throughput Profile settings"
      onClose={doClose}
      content={() => (
        <React.Fragment>
          <p>
            Throughput Profiles. Matched when downlink traffic throughput exceeds a threshold.
          </p>
          <ul>
            <li>
              <b>NAME</b>: Profile name.
            </li>
            <li>
              <b>THRESHOLD-Mbps</b>: Throughput threshold in Mbps.
            </li>
          </ul>
        </React.Fragment>
      )}
    />
  );
};

export default ThroughputProfileSettingsHelpModal;
